export default __webpack_public_path__ + "static/media/contactBanner.339adbdc.jpeg";